import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';
const TipoLogradouros = () => {
  const [tiposLogradouros, setTiposLogradouros] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    tipo_logradouro: '',
    ativo: true
  });

  useEffect(() => {
    const carregarTiposLogradouros = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/tipos-logradouro`
        );

        if (!response.ok) {
          throw new Error('Erro ao buscar tipos de logradouro');
        }

        const data = await response.json();
        setTiposLogradouros(data);
      } catch (error) {
        console.error('Erro ao carregar tipos de logradouro:', error);
        alert(
          'Erro ao carregar tipos de logradouro. Verifique a conexão com o servidor.'
        );
      }
    };

    carregarTiposLogradouros();
  }, []);

  const filteredTiposLogradouros = tiposLogradouros.filter((tipo) =>
    tipo.tipo_logradouro
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.tipo_logradouro.trim()) {
      alert('A descrição do tipo de logradouro é obrigatória.');
      return;
    }

    try {
      if (editingId) {
        const response = await fetch(
          `${API_BASE_URL}/tipos-logradouro/${editingId}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              tipo_logradouro: formData.tipo_logradouro,
              ativo: formData.ativo
            })
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao atualizar tipo de logradouro');
        }

        const atualizado = await response.json();

        setTiposLogradouros((prev) =>
          prev.map((tipo) => (tipo.id === editingId ? atualizado : tipo))
        );
      } else {
        const response = await fetch(
          `${API_BASE_URL}/tipos-logradouro`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              tipo_logradouro: formData.tipo_logradouro,
              ativo: formData.ativo
            })
          }
        );

        if (!response.ok) {
          throw new Error('Erro ao criar tipo de logradouro');
        }

        const criado = await response.json();

        setTiposLogradouros((prev) => [...prev, criado]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar tipo de logradouro:', error);
      alert(
        'Erro ao salvar tipo de logradouro. Verifique os dados e tente novamente.'
      );
    }
  };

  const handleEdit = (tipo) => {
    setFormData({
      tipo_logradouro: tipo.tipo_logradouro,
      ativo: tipo.ativo
    });
    setEditingId(tipo.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este tipo de logradouro?')) {
      return;
    }

    try {
      const response = await fetch(
        `${API_BASE_URL}/tipos-logradouro/${id}`,
        {
          method: 'DELETE'
        }
      );

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir tipo de logradouro');
      }

      setTiposLogradouros((prev) =>
        prev.filter((tipo) => tipo.id !== id)
      );
    } catch (error) {
      console.error('Erro ao excluir tipo de logradouro:', error);
      alert('Erro ao excluir tipo de logradouro. Tente novamente.');
    }
  };

  const resetForm = () => {
    setFormData({ tipo_logradouro: '', ativo: true });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const selecionado = tiposLogradouros.find((tipo) => tipo.id === id);

    if (!selecionado) {
      return;
    }

    const novoAtivo = !selecionado.ativo;

    try {
      const response = await fetch(
        `${API_BASE_URL}/tipos-logradouro/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            tipo_logradouro: selecionado.tipo_logradouro,
            ativo: novoAtivo
          })
        }
      );

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do tipo de logradouro');
      }

      const atualizado = await response.json();

      setTiposLogradouros((prev) =>
        prev.map((tipo) => (tipo.id === atualizado.id ? atualizado : tipo))
      );
    } catch (error) {
      console.error(
        'Erro ao atualizar status do tipo de logradouro:',
        error
      );
      alert(
        'Erro ao atualizar status do tipo de logradouro. Tente novamente.'
      );
    }
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Tipos de Logradouro</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Tipo de Logradouro' : 'Cadastrar Tipo de Logradouro'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="tipo_logradouro">Tipo de Logradouro *</label>
              <input
                type="text"
                id="tipo_logradouro"
                value={formData.tipo_logradouro}
                onChange={(e) => setFormData({...formData, tipo_logradouro: e.target.value})}
                required
                maxLength={30}
                placeholder="Digite o tipo de logradouro"
              />
            </div>

            <div className="form-group">
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="ativo"
                  checked={formData.ativo}
                  onChange={(e) => setFormData({...formData, ativo: e.target.checked})}
                />
                <label htmlFor="ativo">Ativo</label>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary">
                <FaSave /> {editingId ? 'Atualizar' : 'Cadastrar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
          <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar tipos de logradouros..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredTiposLogradouros.length} registro(s) encontrado(s)</span>
            </div>
            <button 
              className="btn-primary"
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Cadastrar Tipo
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Tipo de Logradouro</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredTiposLogradouros.map(tipo => (
                  <tr key={tipo.id}>
                    <td className="col-id">{tipo.id}</td>
                    <td className="col-nome">{tipo.tipo_logradouro}</td>
                    <td className="col-status">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={tipo.ativo}
                          onChange={() => handleToggleStatus(tipo.id)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(tipo)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(tipo.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredTiposLogradouros.length === 0 && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhum tipo de logradouro encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo tipo de logradouro.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TipoLogradouros;
